import React from "react";
import { List, ListItem, IconButton, Button, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

export default function ReorderableFeaturedList({
  items,
  setItems,
  onRemove,
  onSaveOrder,
  itemLabel,
  msg,
  setMsg,
  idKey = "_id",
  labelKeys = ["title", "name", "_id"],
  renderItem, // <-- NEW
}) {
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(items);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setItems(reordered);
  };

  return (
    <>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="droppable-list">
          {(provided) => (
            <List
              className="listRoot"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {items.map((item, index) => (
                <Draggable
                  key={item[idKey]}
                  draggableId={String(item[idKey])}
                  index={index}
                >
                  {(provided) => (
                    <ListItem
                      className="listItem"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() => onRemove(item[idKey])}
                        >
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      {renderItem
                        ? renderItem(item)
                        : labelKeys.map((k) => item[k]).find(Boolean)}
                    </ListItem>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </List>
          )}
        </Droppable>
      </DragDropContext>
      <Button
        className="actionButton contained"
        variant="contained"
        sx={{ mt: 1, mb: 2 }}
        onClick={onSaveOrder}
      >
        Save Order
      </Button>
      <Typography className="statusMsg" color="primary">
        {msg}
      </Typography>
    </>
  );
}